<template>
  <div v-loading='loading1' class="overflow: auto; height: 75vh;">
    <el-row >
      <el-col :span="22" :offset="1" style="min-height: 90vh;">
        <div class="basics">
          <div class="avatat">
            <el-image
              :src="user.AvatarUrl?'/old/public/'+user.AvatarUrl:'http://expert.ckcest.cn/old/public/autoload/images/avatar.png'"
              fit="fit"
              class="basics_img"
            >
              <div slot="error" class="image-slot">
                <img src="http://expert.ckcest.cn/old/public/autoload/images/avatar.png" alt />
              </div>
            </el-image>
            <el-button @click="dialogFormVisible = true">上传头像</el-button>
          </div>
          <div class="basic_info">
            <div class="info_inp">
              <div>KID：{{Kid}}</div>
              <div>专家姓名：{{user.Name}}</div>
              <div v-if="user.ISNI">ISNI{{user.ISNI}}</div>
              <div :title="user.Subject">
                <span>
                  专家学科：{{!isEdit?'':user.Subject}}
                  <el-input v-if="!isEdit" v-model="user.Subject"></el-input>
                </span>
              </div>
              <div>专家机构：{{user.Organization}}</div>
              <div>
                <span>
                  Email：{{!isEdit?'':user.Email}}
                 <el-input v-if="!isEdit" v-model="user.Email"></el-input>
                </span>
              </div>
              <div>
                <span>
                  手机：{{!isEdit?'':user.Tel}}
                  <el-input v-if="!isEdit" v-model="user.Tel"></el-input>
                </span>
               </div>
            </div>
          </div>
          <div class="basic_resume">
            <span>个人简历</span>
            <el-input
              class="resume_input"
              type="textarea"
              :rows="5"
              placeholder="请输入内容"
              v-model="user.Introduction"
              :disabled="isEdit"
            ></el-input>
            <el-button type="primary" @click="saveIntr">{{isEdit?'编辑':'保存'}}</el-button>
          </div>
        </div>
        <div class="menus">
          <el-row>
            <el-col :span="4">
              <el-menu default-active="1" class="el-menu-vertical-demo" @select="selectMenu">
                <el-menu-item v-for="(item,index) in menu" :key="index" :index="index+1+''">
                  <img src="http://expert.ckcest.cn/autoload/images/icon_paper.png" alt />
                  <span slot="title">{{item.name}}</span>
                </el-menu-item>
              </el-menu>
            </el-col>
            <el-col :span="19">
              <results
                :KID='Kid'
                :code="code"
                :tabelList="dataList"
                :Pages="Pages"
                :searchList="searchList"
                :newResultsData='newResultsData'
                :isNew='isNew'
                @page="editPage"
                @search="search"
                @add="add"
                @edit='edit'
                @del="del"
                @claim='newClaim'
                @uploadFile='uploadFile'
                :userId="id"
                v-loading="loading"
              ></results>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <el-dialog class="claimDialog" title="上传头像" :visible.sync="dialogFormVisible" center>
      <el-upload
        ref="upload"
        action="action"
        :http-request="upload"
        list-type="picture-card"
        :file-list="fileList"
        :on-remove="handleRemove"
        :auto-upload="false"
      >
        <i class="el-icon-plus"></i>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="update">开始上传</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 成果管理页面一样
import {
  upload,
  getExpM,
  getExpC,
  Update,
  getUser,
  addC,
  addM,
  delC,
  delM,
  newResults,
  allresource,
  UpdateM
} from '@/api/claim'
import results from '@/view/claim/results'
export default {
  components: {
    results
  },
  name: 'manage',
  props: {
    isHttp: {
      type: String
    },
    isRoles: {
      type: Boolean,
      default: true
    },
    Kid: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      user: [],
      id: JSON.parse(localStorage.getItem('user')).Id,
      isEdit: true,
      dialogFormVisible: false,
      fileList: [],
      menu: [
        { name: '我的履历' },
        { name: '我的论文' },
        { name: 'SCI收录' },
        { name: 'EI收录' },
        { name: '我的专利' },
        { name: '我的项目' },
        { name: '我的图书' },
        { name: '成果奖励' },
        { name: '会议论文' },
        { name: '学位论文' },
        { name: '我的团队' },
        { name: '我的活动' }
        // { name: '回收站' }
      ],
      dataList: [],
      page: 1,
      Pages: {},
      searchList: [],
      code: '1',
      index: '1',
      loading: false,
      loading1: false,
      newResultsData: [],
      isNew: false
    }
  },
  methods: {
    getUser () {
      let data = {
        id: this.Kid
      }
      getUser(data)
        .then(res => {
          this.loading1 = false
          this.user = res.data
          this.user.Subject = this.user.Subject.slice(0, 100)
        })
        .catch(err => {
          console.log(err)
        })
    },
    saveIntr () {
      if (this.isEdit) {
        this.isEdit = false
      } else {
        this.isEdit = true
        let data = {
          EmployeeId: 0,
          Expert: this.user,
          UserId: this.id + ''
        }
        Update(data).then(res => {
          this.$message({
            message: '修改成功',
            offset: '200'
          })
        })
      }
    },
    handleRemove (file, fileList) {
      console.log(file, fileList)
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    update () {
      this.$refs.upload.submit()
    },
    upload (file) {
      let formData = new FormData()
      const _file = file.file
      formData.append('type', _file.type)
      formData.append('id', _file.uid)
      formData.append('name', _file.name)
      formData.append('lastModifiedDate', _file.lastModifiedDate)
      formData.append('size', _file.size)
      formData.append('file', _file)

      upload(formData).then(res => {
        if (res.status === 1) {
          this.user.AvatarUrl = res.data.savepath.indexOf('newexpert') !== -1 ? res.data.savepath.slice(21, res.data.savepath.length) : res.data.savepath
          let data = {
            EmployeeId: 0,
            Expert: this.user,
            UserId: this.id + ''
          }
          Update(data).then(res => {
            this.$message({
              message: '修改成功',
              offset: '200'
            })
          })
        }
      })
    },
    uploadFile (formData) {
      upload(formData).then(res => {
        console.log(res)
      })
    },
    selectMenu (index) {
      let data
      if (index) {
        this.page = 1
        this.index = index
      }
      index = parseInt(this.index)
      if (index === 1) {
        data = {
          KId: this.Kid,
          OrganizationId: '',
          OrganizationName: '',
          PageIndex: this.page,
          PageSize: 8
        }
        this.code = '1'
      } else if (index === 13) {
        data = {
          IsConfirmed: '1',
          IsDeleted: '0',
          IsValid: '0',
          KId: this.Kid,
          PageIndex: this.page,
          PageSize: 8,
          UserId: this.id
        }
        this.code = '13'
      } else {
        let code = ''
        switch (index) {
          case 2:
            code = 'J'
            break
          case 3:
            code = 'I'
            break
          case 4:
            code = 'E'
            break
          case 5:
            code = 'P'
            break
          case 6:
            code = 'O'
            break
          case 7:
            code = 'B'
            break
          case 8:
            code = 'A'
            break
          case 9:
            code = 'C'
            break
          case 10:
            code = 'D'
            break
          case 11:
            code = 'T'
            break
          case 12:
            code = 'Y'
            break
          default:
            break
        }
        this.code = code
        data = {
          IsValid: true,
          KId: this.Kid,
          PageIndex: this.page,
          PageSize: 8,
          ResourceCode: code,
          UserId: this.id + ''
        }
      }
      this.getExp(data)
    },
    search (data) {
      data.KId = this.$route.query.kid
      console.log(data)
      allresource(data).then(res => {
        this.searchList = res.data
      })
    },
    getExp (data) {
      this.loading = true
      this.dataList = []
      if (this.code === '1') {
        getExpM(data).then(res => {
          this.loading = false
          this.dataList = res.data.Data
          this.Pages = res.data.Pages
        })
      } else {
        getExpC(data).then(res => {
          this.loading = false
          this.dataList = res.data.Data
          this.Pages = res.data.Pages
        })
      }
    },
    editPage (page) {
      this.page = page
      this.selectMenu()
    },
    add (data) {
      this.loading = true
      if (this.code === '1') {
        addM(data).then(res => {
          this.loading = false
          this.selectMenu()
          this.message('添加成功')
        })
      } else {
        addC(data).then(res => {
          this.loading = false
          this.selectMenu()
          this.message('添加成功')
        })
      }
    },
    edit (data) {
      this.loading = true
      if (this.code === '1') {
        UpdateM(data).then(res => {
          this.loading = false
          this.selectMenu()
          this.message('修改成功')
        })
      }
    },
    del (data) {
      this.loading = true
      if (this.code === '1') {
        delM(data).then(res => {
          this.loading = false
          this.message('删除删除')
          this.selectMenu()
        })
      } else {
        delC(data).then(res => {
          this.loading = false
          this.selectMenu()
          this.message('删除成功')
        })
      }
    },
    message (msg) {
      this.$message.close()
      this.$message({
        message: msg,
        offset: '200',
        duration: '2000'
      })
    },
    getNewResults () {
      let data = {
        KId: this.Kid
      }
      newResults(data).then(res => {
        if (res.data.Data.Details) {
          this.isNew = true
          this.newResultsData = res.data.Data.Details
        }
      })
    }
  },
  watch: {
    isHttp: {
      handler (val) {
        if (this.isHttp === '1' && !this.isRoles) {
          this.selectMenu(this.index)
          this.getNewResults()
          this.getUser()
          this.loading1 = true
        }
      }
    }
  },
  mounted () {
    if (this.isHttp === '1' && !this.isRoles) {
      this.selectMenu(this.index)
      this.getNewResults()
      this.getUser()
      this.loading1 = true
    }
  }
}
</script>

<style lang="scss">
.basics {
  padding-bottom: 20px;
  height: 250px;
  margin-top: 50px;
  padding: 20px;
  display: flex;
  flex-direction: row;
  background: #fff;
  .avatat {
    text-align: center;
    width: 150px;
    .el-button {
      margin-top: 10px;
    }
  }
  .basic_info {
    width: 35%;
    height: 100%;
    .info_inp {
      height: 80%;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      color: #838383;
      font-size: 12px;
      margin-left: 20%;
      justify-content: space-between;
      div{
        word-break: break-all;
        .el-input{
          width: 60%;
          .el-input__inner{
            height: 20px;
            line-height: 20px;
          }
        }
      }
    }
    .el-button{
      margin-top: 10px;
      float: right;
      margin-right: 20px;
    }
  }
  .basic_resume {
    border-left: 1px solid #000000;
    width: 50%;
    padding-left: 2%;
    .resume_input {
      margin-top: 1%;
    }
    .el-button {
      margin-top: 2%;
      float: right;
    }
  }
}
.menus {
  background: #fff;
  border: 1px solid rgba(34, 36, 38, 0.15);
  margin-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// src/view/center/menu/results.vue